<template>
    <div class="sports_item_detail sports_register_detail">
      <!-- <img v-if="item_sub_id==2548" class="not" src="https://oss.mcloud.moveclub.cn/mpms/20210628/1624875148-60d9a08c441d3.png" alt=""> -->
      <Form :list="itemDetail.registerform" :team="teamform" :buttonColor="buttonColor" @submit="submit" :statement="itemDetail.statement"/>
      <!-- <div class="sese" v-if="item_sub_id == 2591 || item_sub_id == 2592 || item_sub_id == 2593 || item_sub_id == 2594 || item_sub_id == 2595">请参照示范视频角度及动作，正面/侧面拍摄动作，保证动作标准性，以便系统识别计分，谢谢</div> -->
    </div>
</template>

<script>
    import Footbar from '@/components/footbar/index'
    import Form from '@/components/form/index2.vue'

    import {Empty, Panel, Cell, Button, CellGroup} from 'vant';
    import "./index.less"
    export default {
        computed: {
            buttonColor() {
                let detail = this.detail;
                if (!detail) return '#FF6900';
                return `${detail.tabstyle[0]['color']}`;
            }
        },
        components: {
            Empty,
            Panel,
            Cell,
            Button,
            CellGroup,
            Footbar,
            Form
        },
        props: ['form_id', 'signtype'],
        data() {
            return {
                detail: '',
                itemDetail: "",
                joinList: [],
                teamform: []
            }
        },
        methods: {
            // submit: function (e) {
            //     this.$dialog.confirm({
            //         title: "提示",
            //         confirmButtonText: '确定提交',
            //         message: '信息提交后不可修改,确定提交?',
            //         showCancelButton: true
            //     }).then(() => {

            //         this.$api.sports.submitCompare({cpgid: this.item_sub_id, registerInfo: e}).then((res) => {
            //             if (+res.status === 200) {
            //               if(this.item_sub_id == 2591||this.item_sub_id == 2592||this.item_sub_id == 2593||this.item_sub_id == 2594||this.item_sub_id == 2595){
            //                 this.$router.replace({ name: 'sportsQues', params: { acid: 972 }})
            //               }else{
            //                 this.$router.replace({ name: 'sportsResult', params:this.$route.params})
            //               }

            //             }
            //         })

            //         // on confirm
            //     }).catch(() => {
            //         // on cancel
            //     });


            //     console.log(e)
            // },
						submit: function (e) {
						    this.$dialog.confirm({
						        title: "提示",
						        confirmButtonText: '确定提交',
						        message: '信息提交后不可修改,确定提交?',
						        showCancelButton: true
						    }).then(() => {
						
						        this.$api.sports.submitFormData({formid: this.form_id, op: 1, registerinfo: JSON.stringify(e)}).then((res) => {
						            if (+res.status === 200) {
						              this.$toast({
						              	type: 'success',
						              	message: '提交成功!',
						              	duration: 2000,
						              });
													setTimeout(() => {
														this.$router.go(-1)
													}, 2000)
						
						            }
						        })
						
						        // on confirm
						    }).catch(() => {
						        // on cancel
						    });
						
						
						    console.log(e)
						},
						init2: function () {
						    this.$toast.loading({
						        duration: 0
						    });
								var params = {
									id: this.form_id
								}
								this.$api.sports.getFormConfig(params).then(res => {
									var json = JSON.parse(res['data']['form'])
									res['data']['registerform'] = json[0].attrs;
									this.itemDetail = res['data']
									this.$toast.clear();
								})
								
						    // let params = {cpgid: this.item_sub_id}
						    // Promise.all([this.$api.sports.sportsMain(this.sports_id), this.$api.sports.getComparegame(params)]).then((res) => {
						    //     let {bgstyle, id, tabstyle, introstyle, title} = res[0].data;
						    //     try {
						    //         bgstyle = JSON.parse(bgstyle)
						    //         tabstyle = JSON.parse(tabstyle)
						    //         introstyle = JSON.parse(introstyle)
						    //     } catch (e) {
						    //         console.error(e)
						    //     }
						    //     this.detail = {id, bgstyle, tabstyle, introstyle, title}
						    //     this.joinList = res[1]['list'];
						    //     delete res[1]['data']['list']
						    //     if(this.signtype == 2) {
						    //         this.teamform = this.cf.teamform()
						    //     }
						    //     if (res[1]['data']['registerform']) {
						    //         try {
						    //             res[1]['data']['registerform'] = JSON.parse(res[1]['data']['registerform']);
						                
						    //         } catch (e) {
						    //             console.log(e)
						    //         }
						    //     }
						    //     this.itemDetail = res[1]['data']
						    //     this.$toast.clear();
						    // })
						
						
						},
            init: function () {
                this.$toast.loading({
                    duration: 0
                });
								
                let params = {cpgid: this.item_sub_id}
                Promise.all([this.$api.sports.sportsMain(this.sports_id), this.$api.sports.getComparegame(params)]).then((res) => {
                    let {bgstyle, id, tabstyle, introstyle, title} = res[0].data;
                    try {
                        bgstyle = JSON.parse(bgstyle)
                        tabstyle = JSON.parse(tabstyle)
                        introstyle = JSON.parse(introstyle)
                    } catch (e) {
                        console.error(e)
                    }
                    this.detail = {id, bgstyle, tabstyle, introstyle, title}
                    this.joinList = res[1]['list'];
                    delete res[1]['data']['list']
                    if(this.signtype == 2) {
                        this.teamform = this.cf.teamform()
                    }
                    if (res[1]['data']['registerform']) {
                        try {
                            res[1]['data']['registerform'] = JSON.parse(res[1]['data']['registerform']);
                            
                        } catch (e) {
                            console.log(e)
                        }
                    }
                    this.itemDetail = res[1]['data']
                    this.$toast.clear();
                })


            }
        },
        mounted() {
            this.init2();
        }

    }
</script>
